<div class="cart-preview-card">

  <section class="d-flex justify-content-between align-items-center gap-3 position-relative">
    @if (isSkipped()) {
    <section class="skipped"></section>
    }
    <div class="cart-preview-card__img">
      <a [routerLink]="['/shop/'+(product()?.productUrl || '')]">
        <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image"
          (error)="handleImageError($event)" />
      </a>
    </div>

    <div class="d-flex flex-column justify-content-center flex-grow-1 width-100 gap-2">

      <!-- Name -->
      <a class="title" [routerLink]="['/shop/'+(product()?.productUrl || '')]">
        {{ product().name }}
      </a>

      <div class="d-flex justify-content-between align-items-center">

        <div class="cart-preview-card__content">

          <!-- Display -->
          <span class="subtitle h-auto" [class.d-flex]="isSmallMobile()" [class.flex-column]="isSmallMobile()"
            [class.h-auto]="isSmallMobile()">

            @if (productVariantText()) {
            <span>
              {{productVariantText()}}
            </span>
            } @else if (productPackageText()) {
            <span>
              {{productPackageText()}}
            </span>
            }

            @if (productFrequencyText()) {
            <span>{{productFrequencyText()}}</span>
            }
          </span>

          <!-- Quantity -->
          <div class="input-plus-minus" [class.with-button]="showUpdateButton()">
            @if(allowModification()) {
            <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
              @if (isMoreThanTen()) {
              <input type="text" placeholder="0" matInput appOnlyNumber [(ngModel)]="newQuantity" />
              } @else {
              <mat-select [(ngModel)]="newQuantity" (selectionChange)="onQuantityChange()">
                @for(q of availableQuantities(); track $index){
                <mat-option [value]="q.val">{{ q.name }}</mat-option>
                }
              </mat-select>
              }
            </mat-form-field>

            @if (showUpdateButton()) {
            <button type="button" class="btn btn-primary btn-product-action-mobile" [disabled]="!newQuantity()"
              (click)="validateQuantity()">
              Update
            </button>
            }

            } @else {
            <span class="h4-bold text-secondary-700">
              x {{ newQuantity() }}
            </span>
            }
          </div>

        </div>

        <div class="cart-preview-card__content align-items-end">

          <!-- Price -->
          @if (!isSkipped()) {
          @if (!product().bundle?.items?.length && product().bundle?.priceRange) {
          <span class="price">
            {{ product().bundle.priceRange }}
          </span>
          } @else {
          <section class="d-flex flex-column justify-content-center align-items-center">
            <span class="h8-bold text-black-50">
              {{ (product().price) | currency}} each
            </span>
            <span class="price">
              {{ totalPrice() | currency}}
            </span>
          </section>
          }
          }

          <!-- Tag -->
          @if (showProductStatusTag) {
          <header class="d-flex justify-content-end">
            <span class="cart-preview-card__tag badge " [class.bg-info]="isSkipped()"
              [class.bg-success]="!isSkipped() && isInOrder()" [class.bg-warning]="!isSkipped() && !isInOrder()">
              {{isSkipped() ? 'Skipped' : isInOrder() ? 'In your order' : 'Not yet saved'}}
            </span>
          </header>
          } @else if(isSkipped()) {
          <header class="d-flex justify-content-end z-3">
            <span class="cart-preview-card__tag badge bg-info">
              Skipped
            </span>
          </header>
          }

        </div>

      </div>

    </div>

  </section>

  <!-- Actions -->
  @if(isPreorder()) {
  <app-empty-message message="Pre-ordered items can’t be changed." [width100]="true"></app-empty-message>
  } @else {
  <section class="cart-preview-card__buttons">

    @if (isSkipped()) {
    <button type="button" class="btn btn-outline-primary btn-product-action-mobile" (click)="unskip()">
      Unskip
    </button>
    }

    @if (!isSkipped() && isInOrder() && isSubscription()) {
    <button type="button" class="btn btn-outline-primary btn-product-action-mobile" (click)="skip()">
      Skip
    </button>
    }

    @if(allowModification() && !isSubscription()) {
    <button type="button" class="btn btn-outline-primary btn-product-action-mobile" (click)="prevRemoveCartProduct()">
      Delete
    </button>
    }

    @if (product()?.bundle && product()?.bundle?.items?.length) {
    <button type="button" class="btn btn-outline-primary btn-product-action-mobile justify-self-end"
      data-bs-toggle="collapse" [attr.data-bs-target]="'#toggle_' + product().id" aria-expanded="false"
      aria-controls="collapseExample">
      What's inside
    </button>
    }

  </section>
  }

  @if (product()?.bundle && product()?.bundle?.items?.length) {
  <section class="collapse bg-primary bg-opacity-10 pt-2 rounded-4" [id]="'toggle_'+product().id">
    @for (item of product().bundle.items; track $index) {
    <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
      <div class="col-8">
        <h6 class="h8-semibold">{{ item.name }} {{item.packageName ? (' | ' +
          item.packageName) : (item.display ? (' | ' + item.display) : '')}}</h6>
        @if (item?.presentation) {
        <small class="h7-semibold">
          {{ item.presentation.quantity }}
          {{ item.presentation.type }}
        </small>
        }
      </div>
      <div class="col-4">
        <h6 class="h8-semibold text-end">{{item.quantity}}</h6>
      </div>
    </div>
    }
  </section>

  @if(!isSkipped() && !product().bundle.isLocked) {
  <button type="button" class="btn btn-outline-primary h6-bold btn-product-action-mobile w-100"
    (click)="goToCustomizeBox()">
    Customize Pack
  </button>
  }

  }

</div>